module.exports = __webpack_public_path__ + "static/media/mobile-promos-banner_2.e65eb7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promos-banner/mobile-promos-banner_2.jpg
// module id = 2450
// module chunks = 7